import { Box, Grid, Typography } from "@mui/material";
import OwnerPic from "../assets/aboutmid.avif";
import VerticalDividers from "../components/DividedButton";

const AboutOwner = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <Box sx={{ display: "flex" }}>
          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <img
              src={OwnerPic}
              alt='owners mb'
              width={"50px"}
              style={{ borderRadius: "7px", marginBottom: "16px" }}
            />
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <img
              src={OwnerPic}
              alt='owners'
              width={"80px"}
              style={{ borderRadius: "7px", marginBottom: "16px" }}
            />
          </Box>

          <Box ml={2}>
            {/* Check the git */}
            <Typography>
              Milady Maker is a collection of 10,000 generative pfpNFT's in a
              neochibi aesthetic inspired by street style tribes.
            </Typography>
            <Typography my={3}>
              Category <span style={{ fontWeight: "bold" }}>PFPs</span> 
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} sm={12}>
        <VerticalDividers />
      </Grid>
    </Grid>
  );
};

export default AboutOwner;
